<script>

    import { toast } from 'bulma-toast'

    import { MerchandisesStore, ModalStore } from '../stores'

    import MerchandisesService from '../$services/merchandises.service'
    import NumeralMethods from '../$methods/numeral.methods'

    import SatProducts from '../catalogs/sat.products.svelte'
    import SatUnits from '../catalogs/sat.units.svelte'

    import InputNumber from '../$components/input.number.svelte'
    import InputText from '../$components/input.text.svelte'
    import Message from '../$components/message.svelte'
    import Select from '../$components/select.svelte'
    import Button from '../$components/button.svelte'
    import Value from '../$components/value.svelte'
    import Modal from '../$components/modal.svelte'
    import Form from '../$components/form.svelte'

    export let merchandises = []

    let loading = false
    let data = {}

    getMerchandises()

    async function getMerchandises() {

        loading = true
        const resp = await MerchandisesService.getMerchandises()
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        MerchandisesStore.set(resp.data.merchandises)
    }

    function appendMerchandise() {

        if(!data.productCode)
            return

        if(!data.unitCode)
            return

        merchandises = [data, ...merchandises]
        data = {}

        ModalStore.close()
    }

    function removeMerchandise(index) {
        merchandises = merchandises.filter((item, i) => index != i)
    }

    function onSelect(event) {
        const merchandiseId = event.detail
        data = $MerchandisesStore.find(item => item._id === merchandiseId)
    }

</script>

<Modal id="MerchandisesAppend" title="Agregar mercancia">
    {#if $MerchandisesStore.length}
        <Select on:change={onSelect} label="Mis mercancias" icon="tags"
            options={$MerchandisesStore.map(merchandise => {
                return {value: merchandise._id, text: merchandise.alias}
            })}
        />
        <hr>
    {/if}
    <Form on:submit={appendMerchandise} on:canceled={ModalStore.close} >
        <div class="columns">
            <div class="column">
                <SatProducts bind:productCode={data.productCode} bind:productName={data.productName} bind:productWarning={data.productWarning} />
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <SatUnits bind:unitCode={data.unitCode} bind:unitName={data.unitName} />
            </div>
        </div>
        <div class="columns">
            <div class="column is-4">
                <InputNumber bind:value={data.items} label="Cantidad" icon="list-ol" placeholder="Cantidad de piezas" />
            </div>
            <div class="column">
                <InputNumber bind:value={data.value} label="Valor" icon="dollar-sign" placeholder="Valor en factura" />
            </div>
        </div>
        <div class="columns">
            <div class="column is-4">
                <InputNumber bind:value={data.weight} label="Peso" icon="weight" placeholder="Peso neto de la mercancia" />
            </div>
            <div class="column">
                <InputText bind:value={data.description} label="Descripción" icon="sticky-note" placeholder="Detalles de la mercancia" />
            </div>
        </div>
    </Form>
</Modal>

<div class="columns">
    <div class="column">
        <Button on:click={() => ModalStore.open('MerchandisesAppend')} text="Agregar" icon="plus" color="primary" size="small" />
    </div>
</div>

<Message show={!merchandises.length} message="Debe registrarse todas las mercancias a envíar" />

{#each merchandises as merchandise, index}
    <div class="columns">
        <div class="column">
            <Value label="Items" value={merchandise.items} />
        </div>
        <div class="column">
            <Value label="Valor" value={NumeralMethods.cash(merchandise.value)} />
        </div>
        <div class="column">
            <Value label="Peso" value={merchandise.weight} postfix="KG" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Button on:click={() => removeMerchandise(index)} text="Quitar de la lista" icon="ban" size="small" />
        </div>
        <div class="column">
            <Value label="Producto" value={merchandise.productName} />
        </div>
        <div class="column">
            <Value label="Código" value={merchandise.productCode} />
        </div>
    </div>
    <div class="columns">
        <div class="column"></div>
        <div class="column">
            <Value label="Unidad de medida" value={merchandise.unitName} />
        </div>
        <div class="column">
            <Value label="Código" value={merchandise.unitCode} />
        </div>
    </div>
    <hr>
{/each}
